import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import CannedResponseAPI from '../../api/cannedResponse';
const state = {
  records: [],
  pagination: {
    current_page: 1,
    total_pages: 1,
    total_count: 1,
    per_page: 15,
  },
  lastSearchKey: '',
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getCannedResponses(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getPagination(_state) {
    return _state.pagination;
  },
};

const actions = {
  getCannedResponse: async function getCannedResponse(
    { commit, state  },
    { searchKey, page } = {}
  ) {
    commit(types.default.SET_CANNED_UI_FLAG, { fetchingList: true });
    try {
      commit(types.default.SET_LAST_SEARCH_KEY, { lastSearchKey: searchKey });
      const response = await CannedResponseAPI.get({
        searchKey,
        page,
      });
      if (state.lastSearchKey === searchKey) {
        commit(types.default.SET_CANNED, Array.isArray(response.data) ? response.data : response.data.canned_responses);
        if(response.data.pagination) 
          commit(types.default.SET_PAGINATED_CANNED, response.data);
      }
      commit(types.default.SET_CANNED_UI_FLAG, { fetchingList: false });
    } catch (error) {
      commit(types.default.SET_CANNED_UI_FLAG, { fetchingList: false });
    }
  },

  createCannedResponse: async function createCannedResponse(
    { commit , state , dispatch},
    cannedObj
  ) {
    commit(types.default.SET_CANNED_UI_FLAG, { creatingItem: true });
    try {
      const response = await CannedResponseAPI.create(cannedObj);
      //commit(types.default.ADD_CANNED, response.data);
      commit(types.default.SET_CANNED_UI_FLAG, { creatingItem: false }); 
      await dispatch('getCannedResponse', { 
        page: state.pagination?.current_page 
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_CANNED_UI_FLAG, { creatingItem: false });
      return throwErrorMessage(error);
    }
  },

  updateCannedResponse: async function updateCannedResponse(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_CANNED_UI_FLAG, { updatingItem: true });
    try {
      const response = await CannedResponseAPI.update(id, updateObj);
      commit(types.default.EDIT_CANNED, response.data);
      commit(types.default.SET_CANNED_UI_FLAG, { updatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.default.SET_CANNED_UI_FLAG, { updatingItem: false });
      return throwErrorMessage(error);
    }
  },

  deleteCannedResponse: async function deleteCannedResponse({ commit , state , dispatch}, id) {
    commit(types.default.SET_CANNED_UI_FLAG, { deletingItem: true });
    try {
      await CannedResponseAPI.delete(id);
      commit(types.default.DELETE_CANNED, id);
      commit(types.default.SET_CANNED_UI_FLAG, { deletingItem: true });
      await dispatch('getCannedResponse', { 
        page: state.pagination?.current_page 
      });
      return id;
    } catch (error) {
      commit(types.default.SET_CANNED_UI_FLAG, { deletingItem: true });
      return throwErrorMessage(error);
    }
  },

  clearCannedResponse: async function clearCannedResponse({ commit }) {
    commit(types.default.CLEAR_CANNED);
  },
};

const mutations = {
  [types.default.SET_CANNED_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.CLEAR_CANNED](_state) {
    _state.records = [];
    _state.lastSearchKey = '';
  },

  [types.default.SET_LAST_SEARCH_KEY](_state, { lastSearchKey }) {
    _state.lastSearchKey = lastSearchKey;
  },

  [types.default.SET_CANNED]: MutationHelpers.set,
  [types.default.ADD_CANNED]: MutationHelpers.create,
  [types.default.EDIT_CANNED]: MutationHelpers.update,
  [types.default.DELETE_CANNED]: MutationHelpers.destroy,

  [types.default.SET_PAGINATED_CANNED](_state, data) {
    const { current_page: currentPage, total_pages: totalPages, total_count: totalCount, per_page: perPage } = data.pagination;
    _state.pagination = {
      current_page: currentPage,
      total_pages: totalPages,
      total_count: totalCount,
      per_page: perPage,
    };
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
